module.exports = __webpack_public_path__ + "static/media/campus_17.eb7c8f1e.jpg";